export class Usersignup {
	email! :string;
	nam! : string;
	password! : string;
	login! : string;
}
